import { useMutation, useQueryClient } from 'react-query';
import { forOwn } from 'lodash';

import { createAssignment, destroyAssignment } from '../Services/Api';
import queriesConfig from '../Services/queriesConfig';
import { generateErrorsForWeb } from '../Services/ApiErrorHelpers';

export default ({ onSubmit = () => {}, setError, assignmentId }: any) => {
  const queryClient = useQueryClient();

  const { isLoading: isLoadingCreate, mutate } = useMutation(createAssignment(), {
    useErrorBoundary: true,
    onSuccess: (response: any) => {
      if (response.ok) {
        queryClient.setQueryData(queriesConfig.getPost(response.data.data.id).queryKey, response);
        queryClient.invalidateQueries({ queryKey: ['dashboard-posts'] });
        onSubmit();
      } else {
        forOwn(generateErrorsForWeb(response.data), (message, key) => setError(key, message));
      }
    },
  });
  const { isLoading: isLoadingDestroy, mutate: unassign } = useMutation(
    destroyAssignment(assignmentId),
    {
      useErrorBoundary: true,
      onSuccess: (response: any) => {
        if (response.ok) {
          queryClient.setQueryData(queriesConfig.getPost(response.data.data.id).queryKey, response);

          onSubmit();
        } else {
          forOwn(generateErrorsForWeb(response.data), (message, key) => setError(key, message));
        }
      },
    },
  );

  const assign = (data: any) => {
    mutate(data);
  };

  return { assign, unassign, isLoading: isLoadingCreate || isLoadingDestroy };
};
